import styled from "styled-components";

export const StyledTableContainer = styled.div`
  margin: 20px 0;
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  overflow: hidden;
`;

export const StyledTableRow = styled.tr`
  &:nth-of-type(even) {
    background-color: #f8f9fa;
  }
  
  &:hover {
    background-color: #e3f2fd;
  }
  
  transition: background-color 0.2s ease;
`;

export const StyledTableCell = styled.td`
  padding: 12px 16px;
  border-bottom: 1px solid #e0e0e0;
  font-size: 14px;
  color: #333333;
  
  &:first-of-type {
    padding-left: 24px;
  }
  
  &:last-of-type {
    padding-right: 24px;
    width: 60px;
  }
`;

export const StyledTableHeader = styled.th`
  padding: 16px;
  background-color: #f5f5f5;
  border-bottom: 2px solid #e0e0e0;
  font-weight: 600;
  font-size: 14px;
  color: #555555;
  text-align: left;
  
  &:first-of-type {
    padding-left: 24px;
  }
  
  &:last-of-type {
    padding-right: 24px;
    width: 60px;
  }
`;

export const StyledSearchInput = styled.input`
  width: 100%;
  padding: 12px 16px;
  margin: 20px 0;
  border: 1px solid #d0d0d0;
  border-radius: 4px;
  font-size: 14px;
  
  &:focus {
    outline: none;
    border-color: #1976d2;
    box-shadow: 0 0 0 2px rgba(25, 118, 210, 0.2);
  }
  
  &::placeholder {
    color: #999999;
  }
`;

export const StyledPaginationContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 0;
  margin: 16px 0;
`;

export const StyledPaginationInfo = styled.span`
  font-size: 14px;
  color: #666666;
`;

export const StyledPaginationButton = styled.button`
  padding: 8px 16px;
  margin: 0 4px;
  border: 1px solid #d0d0d0;
  border-radius: 4px;
  background-color: #ffffff;
  color: #333333;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:hover:not(:disabled) {
    background-color: #f0f0f0;
    border-color: #b0b0b0;
  }
  
  &:disabled {
    background-color: #f5f5f5;
    color: #999999;
    cursor: not-allowed;
    border-color: #e0e0e0;
  }
  
  &:active:not(:disabled) {
    background-color: #e0e0e0;
  }
`;

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px 20px;
  color: #666666;
`;

export const ErrorContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px 20px;
  color: #d32f2f;
  font-weight: 500;
`;

export const EmptyContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px 20px;
  color: #999999;
  font-style: italic;
`;